import { Account, Cart, nativeAppHeaders } from '@ynap/api-utils'
import { delay } from '@ynap/promise-utils'
import { ADD_ADDRESS_REQUEST, ADD_ADDRESS_SUCCESS, ADD_ADDRESS_ERROR } from '../constants/ActionTypes'
import { getWatsonConfig, getTimeout, getDelay } from '@ynap/cart-state/src/selectors/getConfig'
import wrapFetchWithJSON from './common/wrapFetchWithJSON'
import { getLocale } from '@ynap/cart-state'
import { FormValues, trimValues } from '@ynap/form'
import { getAdditionalCheckoutHeaders } from '../utils/checkoutActionUtils'
import type { Dispatch } from 'redux'
import { Address, ShoppingCart } from 'app/types/common-types'

function addAddressRequest() {
    return {
        type: ADD_ADDRESS_REQUEST,
    }
}

function addAddressSuccess(data: { addressId: number | string; shoppingCart: ShoppingCart }) {
    return {
        type: ADD_ADDRESS_SUCCESS,
        payload: data,
    }
}

function addAddressError(error: any) {
    return {
        type: ADD_ADDRESS_ERROR,
        error,
    }
}

export default function addAddress(address: Address) {
    return (dispatch: Dispatch, getState: () => any, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const fetchJSON = wrapFetchWithJSON(fetch, getTimeout(state))
        const { langId } = getLocale(state)
        const additionalHeaders = {
            ...nativeAppHeaders(state.deviceType),
            ...getAdditionalCheckoutHeaders(state),
        }

        address.externalAddressValidation = 'true'

        dispatch(addAddressRequest())

        const promise = fetchJSON(Account.addAddress({ address: trimValues(address as unknown as FormValues), ...watsonConfig })).then(({ addressId }) =>
            fetchJSON(Cart.getCart({ ...watsonConfig, langId, additionalHeaders })).then((shoppingCart: ShoppingCart) => ({ shoppingCart, addressId }))
        )

        return delay(promise, getDelay(state))
            .then((data: { addressId: number | string; shoppingCart: ShoppingCart }) => dispatch(addAddressSuccess(data)))
            .catch((error: any) => {
                dispatch(addAddressError(error))
                throw error
            })
    }
}
